import Wojak_5 from "@/assets/quiz/score_thumbnails/wojak_5.webp";
import Wojak_10 from "@/assets/quiz/score_thumbnails/wojak_10.webp";
import Wojak_20 from "@/assets/quiz/score_thumbnails/wojak_20.webp";
import Wojak_30 from "@/assets/quiz/score_thumbnails/wojak_30.webp";
import Wojak_40 from "@/assets/quiz/score_thumbnails/wojak_40.webp";
import Wojak_50 from "@/assets/quiz/score_thumbnails/wojak_50.webp";
import Wojak_60 from "@/assets/quiz/score_thumbnails/wojak_60.webp";
import Wojak_70 from "@/assets/quiz/score_thumbnails/wojak_70.webp";
import Wojak_80 from "@/assets/quiz/score_thumbnails/wojak_80.webp";
import Wojak_90 from "@/assets/quiz/score_thumbnails/wojak_90.webp";
import Wojak_94 from "@/assets/quiz/score_thumbnails/wojak_94.webp";
import Wojak_95 from "@/assets/quiz/score_thumbnails/wojak_95.webp";

export const getScorePercentage = (label: string) => {
  const [correct, total] = label.split("/");
  return (parseInt(correct) / parseInt(total)) * 100;
};

export const getScoreThumbnail = (scorePercentage: number) => {
  if (scorePercentage < 5) return Wojak_5;
  if (scorePercentage < 10) return Wojak_10;
  if (scorePercentage < 20) return Wojak_20;
  if (scorePercentage < 30) return Wojak_30;
  if (scorePercentage < 40) return Wojak_40;
  if (scorePercentage < 50) return Wojak_50;
  if (scorePercentage < 60) return Wojak_60;
  if (scorePercentage < 70) return Wojak_70;
  if (scorePercentage < 80) return Wojak_80;
  if (scorePercentage < 90) return Wojak_90;
  if (scorePercentage < 95) return Wojak_94;
  if (scorePercentage >= 95) return Wojak_95;
  return Wojak_50;
};

export const getExternalScoreThumbnail = (scorePercentage: number) => {
  if (scorePercentage < 5) return "https://i.imgur.com/aB8o0TA.png";
  if (scorePercentage < 10) return "https://i.imgur.com/oRTnmGO.png";
  if (scorePercentage < 20) return "https://i.imgur.com/Kpyvjp3.png";
  if (scorePercentage < 30) return "https://i.imgur.com/RZoBJAx.png";
  if (scorePercentage < 40) return "https://i.imgur.com/ziLHYzb.png";
  if (scorePercentage < 50) return "https://i.imgur.com/YPcA0vg.png";
  if (scorePercentage < 60) return "https://i.imgur.com/61fAJ7M.png";
  if (scorePercentage < 70) return "https://i.imgur.com/NvHV0B7.png";
  if (scorePercentage < 80) return "https://i.imgur.com/7DDT5MH.png";
  if (scorePercentage < 90) return "https://i.imgur.com/K5u86gN.png";
  if (scorePercentage < 95) return "https://i.imgur.com/XxK9uj9.png";
  if (scorePercentage >= 95) return "https://i.imgur.com/2uggcoq.png";
  return "https://i.imgur.com/YPcA0vg.png";
};

export const formatTime = (totalSeconds: number) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const secs = totalSeconds % 60;

  let timeString = "";

  if (hours > 0) {
    timeString += `${hours}h `;
  }
  if (minutes > 0) {
    timeString += `${minutes}m `;
  } else if (hours > 0) {
    timeString += `${minutes}m `;
  }
  timeString += `${secs}s`;

  return timeString;
};
